import { render, staticRenderFns } from "./hospital.vue?vue&type=template&id=e185fac4&scoped=true&"
import script from "./hospital.vue?vue&type=script&lang=js&"
export * from "./hospital.vue?vue&type=script&lang=js&"
import style0 from "./hospital.vue?vue&type=style&index=0&id=e185fac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e185fac4",
  null
  
)

export default component.exports